<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card-main grid-layout">
            <div
              v-for="(obj, index) in orderInfos.filter((input) => 'billingOrder.detalhar.billingClientEmail' != input.name)"
              :key="index"
              :class="getClassesByTheElement(obj)"
            >
              <label>{{ obj.label }}:</label>
              {{ formatedValue(model[obj.name], obj) }}
            </div>
          </q-card-section>
          <dynamic-compositions
            class="col-start-1 col-end-12"
            ref="compositions"
            :compositions-elm="formateInputsArray"
            @composition-button-click="actionButtonClickHandler"
          />
          <label class="total-value" style="margin-right:40px">TOTAL {{totalValue()}}</label>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>

import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
const { page, pageDetail } = JtCrud

@Component({
  mixins: [page, pageDetail],
  name: 'billingOrderActionPageDetail',
  provide () {
    return {
      jtdynamicform: this
    }
  },

  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class BillingOrderActionPageDetail extends Vue {
  totalValue () {
    let total = Number(0)
    this.forms[0].dadosForm.billingOrderItems?.forEach(billingOrderItem => { total += billingOrderItem.value })
    return total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  @Watch('forms')
  onServiceTypeChange () {
    this.totalValue()
  }

  get orderInfos () {
    const listContracMinimumBillingOrder = this.forms[0].relacionamentos.contractMinimumBillingGrid?.filter(item => item.serviceType === this.model.serviceType_chCodigo)
    if (listContracMinimumBillingOrder && listContracMinimumBillingOrder.length > 0) {
      this.model.priority = listContracMinimumBillingOrder[0].priority < 1 ? this.$gettext('NO') : this.$gettext('YES')
    } else {
      this.model.priority = this.$gettext('NO')
    }
    return this.computedInputsTypeElements
  }
}
export default BillingOrderActionPageDetail
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

for num in 1 .. 12 {
  .col-start-{num} {
    grid-column-start: num;
  }
}

for num in 1 .. 13 {
  .col-end-{num} {
    grid-column-end: num;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
  padding: 15px 0;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.row-grey {
  background: $ice;
}

</style>
